"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const isString_1 = __importDefault(require("lodash/isString"));
const fieldTypes_1 = __importDefault(require("../../fieldTypes"));
const has_1 = __importDefault(require("lodash/has"));
function default_1(type) {
    if ((0, isPlainObject_1.default)(type)) {
        if (type._isFieldType)
            return 'custom';
        return 'plainObject';
    }
    if ((0, isArray_1.default)(type))
        return 'array';
    if (type === String)
        return 'string';
    if (type === Date)
        return 'date';
    if (type === Number)
        return 'number';
    if (type === Boolean)
        return 'boolean';
    if (!(0, isString_1.default)(type)) {
        throw new Error('Field type is invalid. Pass a string or a custom field type. Got ' + type);
    }
    const exists = (0, has_1.default)(fieldTypes_1.default, type);
    if (!exists) {
        throw new Error('Field type does not exist');
    }
    return type;
}
exports.default = default_1;
